define([
	"dojo/_base/declare",
	"csi/action/AggregateController",
	"csi/xml",
	"csi/xml/Query",
	"csi/reflection",
	"SourcingOrders"
], function(declare,AggregateController,xml,Query,reflection,SourcingOrders) {

	return declare(AggregateController, {
		applyActionFilters: function(/*csi.view.Widget*/view) {
			// summary: apply query filter for Orders view depending on the Sourcing Orders configuration settings		
			var nodeShipmentTerms = this.getNode() || this.getParent();
			if (nodeShipmentTerms) {
				var config = reflection.getObject(SourcingOrders.CONFIG);
				var	query;
				
				// 1 shipment per PO and no shared shipment between POs
				if (config.OneShipmentsPerPO && !config.AllowSharedShipmentsPerPO) {
					// order's PurchasedOrder equals nodeShipmentTerms
					query = new Query().RefAttr("ShipmentTerms", xml.OP_EQUALS, nodeShipmentTerms.$URL, "Child:PO");
				}
				
				// 1 shipment per PO and shared shipment between POs
				else if (config.OneShipmentsPerPO && config.AllowSharedShipmentsPerPO) {
					// order's PurchasedOrder has no ShipmentTerms or its ShipmentTerms equals nodeShipmentTerms 
					query = new Query();
					query.Or()
						.RefAttr("ShipmentTerms", xml.OP_EQUALS, nodeShipmentTerms.$URL, "Child:PO")
						.Attr2("ShipmentTerms", xml.OP_EQUALS, {"Path":"Child:PO", "Dimension":0 });				
				}

				if (query) {	
					view.relRoot.addQuery(query);
				}
				
				this.inherited(arguments);
			}
		}
	});
});